import Api from '@/api'

export default {
  namespaced: true,
  state: {
    templates: [],
    template: null,
    providers: []
  },

  mutations: {
    setTemplates(state, templates) {
      state.templates = templates
    },

    clearTemplates(state) {
      state.templates = null
    },

    setTemplate(state, template) {
      state.template = template
    },

    setProviders(state, providers) {
      state.providers = providers
    }
  },

  actions: {
    async getTemplates({ commit }) {
      const { data } = await Api.get(`templates`)
      commit('setTemplates', data.data)
    },

    async getTemplate({ commit }, id) {
      const { data } = await Api.get(`templates/${id}`)
      commit('setTemplate', data.data)
    },

    async getProviders({ commit }, id) {
      const { data } = await Api.get(`templates/${id}/licence-provider`)
      commit('setProviders', data.data)
      commit('setTemplate', data.template)
    }
  },

  getters: {
    templates(state) {
      return state.templates
    },
    template(state) {
      return state.template
    },
    providers(state) {
      return state.providers
    }
  }
}
